import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPreassignOrderQuickInfoTable extends Layout {
    labelPreassignments: Label;
    sourcePreassignments: DataSource;
    tablePreassignOrders: Table;
}
